import { Col, Row, Card, Button } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import Title from "antd/lib/typography/Title";
import TinyDivider from "components/TinyDivider/TinyDivider";
import useViewport from "components/UseViewport/UseViewport";
import React from "react";
import { Link } from "react-router-dom";

interface Props {
  imageLink: string;
  imageAlt: string;
  title: string;
  text: string;
  positionLeft: boolean;
  urlLink: string;
}

const FrontPageModule: React.FC<Props> = ({ imageLink, imageAlt, title, text, positionLeft, urlLink }) => {
  const { width } = useViewport();
  const breakpoint = 750;
  return (
    <>
      {width > breakpoint ? (
        <Row justify="center" style={{ marginTop: "6em", width: "100%" }}>
          {positionLeft ? (
            <Col style={{ width: "50%" }}>
              <img
                src={imageLink}
                alt={imageAlt}
                width="100%"
                style={{
                  boxShadow: "1px 3px 4px rgb(0 0 0 / 0.1)",
                  borderRadius: "var(--border-radius)",
                }}
              />
            </Col>
          ) : null}
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "left",
              paddingLeft: "5%",
              paddingRight: "10%",
              width: "50%",
            }}
          >
            <Row>
              <Title level={2}>{title}</Title>
            </Row>
            <Row>
              <TinyDivider width="7em" />
            </Row>
            <Row>
              <Paragraph style={{ fontSize: "16px" }}>{text}</Paragraph>
            </Row>
            <Row>
              <Link to={urlLink}>
                <Button type="primary" size="large" style={{ fontSize: "1em" }}>
                  Se mer
                </Button>
              </Link>
            </Row>
          </Col>
          {!positionLeft ? (
            <Col style={{ width: "50%" }}>
              <img
                src={imageLink}
                alt={imageAlt}
                width="100%"
                style={{
                  boxShadow: "1px 3px 4px rgb(0 0 0 / 0.1)",
                  borderRadius: "var(--border-radius)",
                }}
              />
            </Col>
          ) : null}
        </Row>
      ) : (
        <Row justify="center">
          <Card
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "left",
              width: "100%",
              margin: "2em",
            }}
          >
            <Row>
              <img src={imageLink} alt={imageAlt} width="100%" />
            </Row>
            <Row style={{ marginTop: "2%" }}>
              <Title level={4}>{title}</Title>
            </Row>
            <Row>
              <TinyDivider width="7em" />
            </Row>
            <Row>
              <Paragraph>{text}</Paragraph>
            </Row>
            <Row>
              <Link to={urlLink}>
                <Button type="primary" size="large" style={{ fontSize: "1em" }}>
                  Se mer
                </Button>
              </Link>
            </Row>
          </Card>
        </Row>
      )}
    </>
  );
};

export default FrontPageModule;
